<script>
  import { AppController } from '../AppController.js';
  import SectionHeader from '../components/SectionHeader.svelte';
  import { toast } from '../components/Toast.svelte';
  import { AppFactory } from '../util.js';
  import { showLoading } from '../components/Overlay.svelte';

  import { fade } from 'svelte/transition';
  import { form } from '../validate.js';
  import { push } from 'svelte-spa-router';
 
  // data
  export let params = {};

  let account = params.account_id ? 
    { ...AppController.getAccount(params.account_id) } :
    AppFactory.getNewAccount();

  let subsection = 'Customer'
  $: isNew = !params.account_id;
  let section = params.account_id ? 'Edit Customer' : 'New Customer';
  let verifyPassword = account.password;

  const { validate, ...accountForm} = form(() => ({
    first_name: { value: account.first_name || '', validators: ["required", "min:1"]},
    last_name: { value: account.last_name || '', validators: ["required", "min:1"]},
    company: { value: account.company || '', validators: ["required", "min:1"]},
    address: { value: account.address || '', validators: ["required", "min:1"]},
    city: { value: account.city || '', validators: ["required", "min:1"]},
    state: { value: account.state || '', validators: ["required", "min:1"]},
    postal_code: { value: account.postal_code || '', validators: ["required", "postal"]},
    phone: { value: account.phone || '', validators: ["required", "phone"]},
    email: { value: account.email || '', validators: ["required", "email"]},
    password: { value: account.password || '', validators: ["required", "min:5", "max:20"]},
    verify_password: { value: verifyPassword || '', validators: ["required", `equal:${account.password}`]},
    alert_phone: { value: account.alert_phone || '', validators: ["required", "phone"]},
    alert_email: { value: account.alert_email || '', validators: ["required", "email"]},
    included_alerts: { value: account.included_alerts || '', validators: ["required"]},
    last_reset: { value: account.last_reset || '', validators: ["required"]}
  }));

  // methods
  const save = async () => {
    try {
      showLoading(true);
      await AppController.saveAccount(account);
      toast('success', 3000, 'Saved', 'Account info was saved successfully');
    } catch (err) {
      toast('danger', 'Error', 'An error occured saving account info.');
      console.log(err);
    } finally {
      showLoading(false);
    }
  }

  const cancel = () => {
    push('/admin/accounts');
  }
</script>
<div in:fade="{{duration: 1000}}">
  <SectionHeader section={section} subsection={subsection}>
  </SectionHeader>
  {#if account && accountForm}
    <form class="forms-sample">
      <div class='row'>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Company Info</h4>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-first-name" class='required-field'>Contact First Name</label>
                    <input 
                      type="text" 
                      bind:value={account.first_name} 
                      use:validate={account.first_name}
                      class="form-control" 
                      class:border-danger={(!$accountForm.first_name.valid && !isNew) ||
                        (!$accountForm.first_name.valid && isNew && $accountForm.first_name.dirty)}
                      id="input-first-name" 
                      placeholder="First Name">
                      {#if ($accountForm.first_name.errors.includes('required') && !isNew) || 
                        ($accountForm.first_name.errors.includes('required') && isNew && $accountForm.first_name.dirty)}
                      <p class='text-danger text-small'>Contact First name is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-last-name" class='required-field'>Contact Last Name</label>
                    <input 
                      type="text" 
                      bind:value={account.last_name} 
                      use:validate={account.last_name}
                      class="form-control" 
                      class:border-danger={(!$accountForm.last_name.valid && !isNew) ||
                        (!$accountForm.last_name.valid && isNew && $accountForm.last_name.dirty)}
                      id="input-last-name" 
                      placeholder="Last Name">
                    {#if ($accountForm.last_name.errors.includes('required') && !isNew) || 
                          ($accountForm.last_name.errors.includes('required') && isNew && $accountForm.last_name.dirty)}
                      <p class='text-danger text-small'>Contact Last name is required</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-company" class='required-field'>Company Name</label>
                    <input 
                      type="text" 
                      bind:value={account.company} 
                      use:validate={account.company}
                      class="form-control"
                      class:border-danger={(!$accountForm.company.valid && !isNew) ||
                        (!$accountForm.company.valid && isNew && $accountForm.company.dirty)}
                      id="input-company" 
                      placeholder="Company Name">
                      {#if ($accountForm.company.errors.includes('required') && !isNew) || 
                        ($accountForm.company.errors.includes('required') && isNew && $accountForm.company.dirty)}
                      <p class='text-danger text-small'>Company name is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-address" class='required-field'>Address</label>
                    <input 
                      type="text" 
                      bind:value={account.address} 
                      use:validate={account.address}
                      class="form-control"
                      class:border-danger={(!$accountForm.address.valid && !isNew) ||
                        (!$accountForm.address.valid && isNew && $accountForm.address.dirty)}
                      id="input-address" 
                      placeholder="Address">
                    {#if ($accountForm.address.errors.includes('required') && !isNew) || 
                      ($accountForm.address.errors.includes('required') && isNew && $accountForm.address.dirty)}
                      <p class='text-danger text-small'>Address is required</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-city" class='required-field'>City</label>
                    <input 
                      type="text" 
                      bind:value={account.city} 
                      use:validate={account.city}
                      class="form-control"
                      class:border-danger={(!$accountForm.city.valid && !isNew) ||
                        (!$accountForm.city.valid && isNew && $accountForm.city.dirty)}
                      id="input-city" 
                      placeholder="City">
                    {#if ($accountForm.city.errors.includes('required') && !isNew) || 
                      ($accountForm.city.errors.includes('required') && isNew && $accountForm.city.dirty)}
                      <p class='text-danger text-small'>City is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-state" class='required-field'>State</label>
                    <input 
                      type="text" 
                      bind:value={account.state} 
                      use:validate={account.state}
                      class="form-control"
                      class:border-danger={(!$accountForm.state.valid && !isNew) ||
                        (!$accountForm.state.valid && isNew && $accountForm.state.dirty)} 
                      id="input-state" 
                      placeholder="State">
                    {#if ($accountForm.state.errors.includes('required') && !isNew) || 
                      ($accountForm.state.errors.includes('required') && isNew && $accountForm.state.dirty)}
                      <p class='text-danger text-small'>State is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-postal" class='required-field'>Postal Code</label>
                    <input 
                      type="text" 
                      bind:value={account.postal_code} 
                      use:validate={account.postal_code}
                      class="form-control" 
                      class:border-danger={(!$accountForm.postal_code.valid && !isNew) ||
                        (!$accountForm.postal_code.valid && isNew && $accountForm.postal_code.dirty)}
                      id="input-postal"
                      placeholder='Postal Code'>
                    {#if (($accountForm.postal_code.errors.includes('required') || $accountForm.postal_code.errors.includes('postal')) && !isNew) ||
                      (($accountForm.postal_code.errors.includes('required') || $accountForm.postal_code.errors.includes('postal')) && isNew && $accountForm.postal_code.dirty)}
                      <p class='text-danger text-small'>Valid postal code is required (eg 55449 or 55449-9090)</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-email" class='required-field'>Email</label>
                    <input 
                      type="text" 
                      bind:value={account.email} 
                      use:validate={account.email}
                      class="form-control"
                      class:border-danger={(!$accountForm.email.valid && !isNew) ||
                        (!$accountForm.email.valid && isNew && $accountForm.email.dirty)}
                      id="input-email" 
                      placeholder="Email">
                    {#if (($accountForm.email.errors.includes('required') || $accountForm.email.errors.includes('email')) && !isNew) ||
                      (($accountForm.email.errors.includes('required') || $accountForm.email.errors.includes('email')) && isNew && $accountForm.email.dirty)}
                      <p class='text-danger text-small'>Email is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-password" class='required-field'>Password</label>
                    <input 
                      type="text" 
                      bind:value={account.password} 
                      use:validate={account.password}
                      class="form-control"
                      class:border-danger={(!$accountForm.password.valid && !isNew) ||
                        (!$accountForm.password.valid && isNew && $accountForm.password.dirty)} 
                      id="input-password" 
                      placeholder="Password">
                    {#if (($accountForm.password.errors.includes('required') || $accountForm.password.errors.includes('min') || $accountForm.password.errors.includes('max')) && !isNew) ||
                      (($accountForm.password.errors.includes('required') || $accountForm.password.errors.includes('min') || $accountForm.password.errors.includes('max')) && isNew && $accountForm.password.dirty)}
                      <p class='text-danger text-small'>Password is required and must be between 5 and 20 characters</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-verify-password" class='required-field'>Verify Password</label>
                    <input 
                      type="text" 
                      bind:value={verifyPassword} 
                      use:validate={verifyPassword}
                      class="form-control" 
                      class:border-danger={(!$accountForm.verify_password.valid && !isNew) ||
                        (!$accountForm.verify_password.valid && isNew && $accountForm.verify_password.dirty)} 
                      id="verify-password"
                      placeholder='Verify Password'>
                    {#if (($accountForm.verify_password.errors.includes('required') || $accountForm.verify_password.errors.includes('equal')) && !isNew) ||
                      (($accountForm.verify_password.errors.includes('required') || $accountForm.verify_password.errors.includes('equal')) && isNew && $accountForm.verify_password.dirty)}
                      <p class='text-danger text-small'>Password does not match</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="input-phone" class='required-field'>Phone</label>
                    <input 
                      type="text" 
                      bind:value={account.phone} 
                      use:validate={account.phone}
                      class="form-control"
                      class:border-danger={(!$accountForm.phone.valid && !isNew) ||
                        (!$accountForm.phone.valid && isNew && $accountForm.phone.dirty)} 
                      id="input-phone" 
                      placeholder="Phone">
                    {#if (($accountForm.phone.errors.includes('required') || $accountForm.phone.errors.includes('phone')) && !isNew) ||
                      (($accountForm.phone.errors.includes('required') || $accountForm.phone.errors.includes('phone')) && isNew && $accountForm.phone.dirty)}
                      <p class='text-danger text-small'>Must be valid phone number (eg 612-633-9090 or (612) 633-9090)</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-4'>
                  <div class="form-group">
                    <label for="timezone" class="required-field">Timezone</label>
                    <select 
                      bind:value={account.timezone}
                      class="form-control" 
                      id="sendTime">
                        <option value='America/Anchorage'>America/Anchorage</option>
                        <option value='America/Chicago'>America/Chicago</option>
                        <option value='America/Denver'>America/Denver</option>
                        <option value='Pacific/Honolulu'>Pacific/Honolulu</option>
                        <option value='America/Los_Angeles'>America/Los_Angeles</option>
                        <option value='America/New_York'>America/New_York</option>    
                    </select>
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-4'>
                  <div class='form-group'>
                    <label for='accountKey'>Account Key</label>
                    <input id='accountKey' class='form-control' bind:value={account.account_id} disabled/>     
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>
      <div class='row mt-3'>
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Alert Config</h4>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label 
                      for="input-included-alerts"
                      class='required-field'>
                      Included Alerts
                    </label>
                    <input 
                      type="number" 
                      bind:value={account.included_alerts} 
                      class="form-control" 
                      class:border-danger={(!$accountForm.included_alerts.valid && !isNew) ||
                        (!$accountForm.included_alerts.valid && isNew && $accountForm.included_alerts.dirty)} 
                      id="input-included-alerts" 
                      placeholder="Included alerts">
                    {#if ($accountForm.included_alerts.errors.includes('required') && !isNew) || 
                      ($accountForm.included_alerts.errors.includes('required') && isNew && $accountForm.included_alerts.dirty)}
                      <p class='text-danger text-small'>Included alerts is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label 
                      for="input-reset-date"
                      class='required-field'>
                      Reset Date
                    </label>
                    <input 
                      type="date" 
                      bind:value={account.last_reset} 
                      class="form-control" 
                      class:border-danger={(!$accountForm.last_reset.valid && !isNew) ||
                        (!$accountForm.last_reset.valid && isNew && $accountForm.last_reset.dirty)} 
                      id="input-reset-date" 
                      placeholder="Alert count reset date">
                    {#if ($accountForm.last_reset.errors.includes('required') && !isNew) || 
                      ($accountForm.last_reset.errors.includes('required') && isNew && $accountForm.last_reset.dirty)}
                      <p class='text-danger text-small'>Included alerts is required</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-alert-email" class='required-field'>Email Alert From Email Address</label>
                    <input 
                      type="text" 
                      bind:value={account.alert_email} 
                      use:validate={account.alert_email}
                      class="form-control" 
                      class:border-danger={(!$accountForm.alert_email.valid && !isNew) ||
                        (!$accountForm.alert_email.valid && isNew && $accountForm.alert_email.dirty)}
                      id="input-alert-email" 
                      placeholder="Alert From Email Address">
                    {#if (($accountForm.alert_email.errors.includes('required') || $accountForm.alert_email.errors.includes('email')) && !isNew) ||
                      (($accountForm.alert_email.errors.includes('required') || $accountForm.alert_email.errors.includes('email')) && isNew && $accountForm.alert_email.dirty)}
                      <p class='text-danger text-small'>Email Alert From Email is required</p>
                    {/if}
                  </div>
                </div>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="input-alert-phone" class='required-field'>Voice Alert From Phone Number</label>
                    <input 
                      type="text" 
                      bind:value={account.alert_phone} 
                      use:validate={account.alert_phone}
                      class="form-control" 
                      class:border-danger={(!$accountForm.alert_phone.valid && !isNew) ||
                        (!$accountForm.alert_phone.valid && isNew && $accountForm.alert_phone.dirty)} 
                      id="input-last-name" 
                      placeholder="Alert From Phone Number">
                    {#if (($accountForm.alert_phone.errors.includes('required') || $accountForm.alert_phone.errors.includes('phone')) && !isNew) ||
                      (($accountForm.alert_phone.errors.includes('required') || $accountForm.alert_phone.errors.includes('phone')) && isNew && $accountForm.alert_phone.dirty)}
                      <p class='text-danger text-small'>Must be valid phone number (eg 612-633-9090 or (612) 633-9090)</p>
                    {/if}
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-12'>
                  <div class='form-group'>
                    <label for="sync-databases">Sync Databases</label>
                    <textarea class='form-control' id='sync-databases' bind:value={account.databases}></textarea>
                  </div>
                </div>
              </div>
              <div class='row'>
                <div class='col-md-6'>
                  <div class="form-group">
                    <label for="alert-voice" class='required-field'>Select Alert Voice</label>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice1" 
                        bind:group={account.alert_voice}
                        value={'MALE1'}>
                        <label class="form-check-label" for="alertVoice1">
                          Male Voice 1
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Roger-male1-This-is-a-Public-Alert-We-have-a-sewer.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice2" 
                        bind:group={account.alert_voice}
                        value={"FEMALE1"}>
                        <label class="form-check-label" for="alertVoice1">
                          Female Voice 1
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Mary-female1-This-is-a-Public-Alert-We-have-a-sewer.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice3" 
                        bind:group={account.alert_voice}
                        value={"FEMALE2"}>
                        <label class="form-check-label" for="alertVoice1">
                          Female Voice 2
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Beth-female2-This-is-a-Public-Alert-We-have-a-sewer.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice4" 
                        bind:group={account.alert_voice}
                        value={"SPANISH1"}>
                        <label class="form-check-label" for="alertVoice1">
                          Female Voice 3 Spanish
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Maria-femaleSpanish1-Esta-es-una-alerta-Tenemos-una-l-nea-de.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                    <div class="form-check">
                      <input 
                        class="form-check-input" 
                        type="radio" 
                        name="alert-voice" 
                        id="alertVoice5" 
                        bind:group={account.alert_voice}
                        value={"FRENCHCANADIAN1"}>
                        <label class="form-check-label" for="alertVoice1">
                          Female Voice 4 French
                        </label>
                        <audio controls style="width: 100%;">
                          <source src="audio/Helene - femaleFrench1-Ceci-est-un-avertissement-public-Nous-a.mp3" type="audio/mpeg">
                            Your browser does not support the audio element.
                        </audio>
                    </div>
                  </div>
                </div>
              </div>
              <div class='mt-2'>
                <button class="btn btn-secondary mr-2" on:click|preventDefault={cancel}>Cancel</button>
                <button class="btn btn-primary mr-2" class:disabled={!$accountForm.valid} disabled={!$accountForm.valid}  on:click|preventDefault={save}>Save</button>
              </div>
            </div>
          </div>
        </div>  
      </div>
    </form>
  {/if}
</div>

<style>
  .required-field::after {
    content: "*";
    color: red;
  }

  .border-light {
    border: 1px solid #f3f3f3;
  }

  .dropdown-menu {
    position: absolute;
    will-change: transform;
    overflow-anchor: auto;
    height: 200px;
    overflow-y: auto;
    top: 0px;
    left: 0px;
    transform: translate3d(0px, 46px, 0px);
  }
</style>